import React, { forwardRef } from 'react'
import { LayoutHeader as LayoutHeaderUI } from '@/componentsUI/Layout';
import Topbar from '@/components/Topbar';
export interface Props {
    className?: string
}

const LayoutHeader = (props: Props, ref) => {
    const { className } = props;
    return (
        <LayoutHeaderUI ref={ref} className={className}>
            <Topbar />
        </LayoutHeaderUI>
    )
}

export default forwardRef(LayoutHeader)
